var map = {
	"./BarCode.svg": 61039,
	"./EllipseIcon.svg": 18542,
	"./H.svg": 46255,
	"./HLine.svg": 21893,
	"./ImageIcon.svg": 94687,
	"./QrCode.svg": 42951,
	"./RectIcon.svg": 39724,
	"./TableIcon.svg": 77724,
	"./TextIcon.svg": 23027,
	"./TextLong.svg": 87762,
	"./VLine.svg": 23611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53946;